export const baseURLlocal = 'http://localhost:8080';
export const baseURLmain = 'https://ryouomoichecker.yt8492.com/api';
export const baseURL = baseURLlocal;
